module.exports = __webpack_public_path__ + "img/msgold_logo.5956e917.png";